module.exports = __webpack_public_path__ + "img/N326-2-EN.bf81fac7.png";